const clamp=value=>Math.max(0,Math.min(1,value));
const ease=value=>{const t=clamp((value-.12)/.76);return t*t*(3-2*t);};
const timeline=(progress,count)=>{
 const total=Math.max(1,count),raw=clamp(progress)*(total-1),index=Math.floor(raw);
 const position=index+ease(raw-index);
 return {position,current:Math.min(total-1,Math.round(position)),progress:clamp(progress)};
};
const travel=(height,count)=>Math.max(0,count-1)*Math.max(500,height*.68);
const progressAt=(top,height,viewportHeight,pinTop=84)=>clamp((pinTop-top)/Math.max(1,height-viewportHeight));
module.exports={clamp,timeline,travel,progressAt};
